const lines = [
  "ATDT KF0WWR",
  "RING... RING...",
  "CONNECT 2400/ARQ/V42BIS",
  "",
  "Keying up ..................... OK",
  "Checking SWR .................. 1.2:1",
  "Syncing to UTC ................ OK",
  "",
  "Welcome to KF0WWR. 73!",
]

const boot = document.getElementById("boot")

if (boot && document.documentElement.classList.contains("booting")) {
  try { localStorage.setItem("kf0wwr-booted", String(Date.now())) } catch {}

  const text = document.getElementById("boot-text")
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
  let done = false

  const finish = () => {
    if (done) return
    done = true
    boot.classList.add("done")
  }

  boot.addEventListener("click", finish)
  window.addEventListener("keydown", finish, { once: true })

  ;(async () => {
    if (document.hidden) return finish()
    for (const line of lines) {
      for (const char of line) {
        if (done) return
        text.textContent += char
        await sleep(12)
      }
      text.textContent += "\n"
      await sleep(line ? 140 : 60)
    }
    await sleep(500)
    finish()
  })()
}
